import { render, staticRenderFns } from "./suggestion-link.vue?vue&type=template&id=67b750d0&scoped=true&"
import script from "./suggestion-link.vue?vue&type=script&lang=ts&"
export * from "./suggestion-link.vue?vue&type=script&lang=ts&"
import style0 from "./suggestion-link.vue?vue&type=style&index=0&id=67b750d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b750d0",
  null
  
)

export default component.exports